export const Button = require('@/components/Form/Button').default
export const Checkbox = require('@/components/Form/Checkbox').default
export const CodeInput = require('@/components/Form/CodeInput').default
export const DateInput = require('@/components/Form/DateInput').default
export const DateSpan = require('@/components/Form/DateSpan').default
export const Dropdown = require('@/components/Form/Dropdown').default
export const Form = require('@/components/Form/Form').default
export const Gender = require('@/components/Form/Gender').default
export const Input = require('@/components/Form/TextInput').default
export const Location = require('@/components/Form/Location').default
export const MonthYear = require('@/components/Form/MonthYear').default
export const PhoneInput = require('@/components/Form/PhoneInput').default
export const Radio = require('@/components/Form/Radio').default
export const RadioGroup = require('@/components/Form/RadioGroup').default
export const Select = require('@/components/Form/Select').default
export const Textarea = require('@/components/Form/Textarea').default
export const Toggle = require('@/components/Form/Toggle').default

export const FileUpload = require('@/components/Form/File/Upload').default
export const OvpHqDoctors = require('@/components/Form/Hq/Doctors').default
